import { getEmbedSchoolId } from "../../embed/school"
import StandaloneEmbedWrapper from "../../embed/StandaloneEmbedWrapper"
import PackageEmbed from "./PackageEmbed"

const DEFAULT_PACKAGE_EMBED_SCHOOL_ID = 7888

type StandalonePackageEmbedContainerProps = {
  location?: {
    search?: string
  }
}

function StandalonePackageEmbedContainer(
  props: StandalonePackageEmbedContainerProps
) {
  const schoolId =
    getEmbedSchoolId({
      search: props.location?.search,
      fallbackSchoolId: DEFAULT_PACKAGE_EMBED_SCHOOL_ID
    }) ?? DEFAULT_PACKAGE_EMBED_SCHOOL_ID

  return (
    <StandaloneEmbedWrapper schoolId={schoolId}>
      <PackageEmbed search={props.location?.search} />
    </StandaloneEmbedWrapper>
  )
}

export default StandalonePackageEmbedContainer
